// extracted by mini-css-extract-plugin
export default {"point":"pointLabel_point__WHRVQ"};